'use client'

import { ContactsManager } from '@repo/contacts-organisations/ContactsManager'
import { Modal } from '@repo/ui/Modal'
import { OrganisationsManager } from '@repo/contacts-organisations/OrganisationsManager'
import { useState } from 'react'
import { useTheme } from '@mui/material/styles'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import PropTypes from 'prop-types'

export const ContactsOrganisationsSelectModal = ({
  open,
  onClose,
  initialSelectedItem,
  mode = 'contacts',
  preSelectExpertTypeId
}) => {
  const theme = useTheme()
  const [selectedItem, setSelectedItem] = useState(initialSelectedItem || null)
  const [isInEditMode, setIsInEditMode] = useState(false)
  const [isInCreateMode, setIsInCreateMode] = useState(false)

  const onEditModeChange = (isInEditMode) => {
    setIsInEditMode(isInEditMode)
  }

  const onCreateModeChange = (isInCreateMode) => {
    setIsInCreateMode(isInCreateMode)
  }

  const managerSx = {
    border: 'none',
    width: '100%',
    height: 'calc(100% - 120px)',
    backgroundColor: 'transparent',
    marginTop: 0,
    minHeight: '100px',
    padding: '14px 0px',
    '[data-testid="newButton"]': {
      right: 0
    },
    '[data-testid="ContactsOrganisationsPreview"]': {
      pr: '30px'
    }
  }

  return (
    <div data-testid="ContactsOrganisationsSelectModal">
      <Modal
        open={open}
        handleClose={() => onClose()}
        title={`Select ${mode === 'contacts' ? 'contact' : 'organisation'}`}
        sx={{
          maxWidth: '1200px',
          width: 'calc(100% - 24px)',
          height: 'calc(100% - 24px)',
          maxHeight: '1200px'
        }}
        theme={theme}
      >
        <hr
          style={{
            opacity: 0.12,
            borderColor: theme?.palette?.support?.navy || 'black',
            borderTop: 'none'
          }}
        />

        {mode === 'contacts' ? (
          <ContactsManager
            preSelectExpertTypeId={preSelectExpertTypeId}
            onSelect={setSelectedItem}
            initialSelectedItem={initialSelectedItem}
            sx={managerSx}
            onEditModeChange={onEditModeChange}
            onCreateModeChange={onCreateModeChange}
          />
        ) : (
          <OrganisationsManager
            preSelectExpertTypeId={preSelectExpertTypeId}
            onSelect={setSelectedItem}
            initialSelectedItem={initialSelectedItem}
            sx={managerSx}
            onEditModeChange={onEditModeChange}
            onCreateModeChange={onCreateModeChange}
          />
        )}

        <hr
          style={{
            opacity: 0.12,
            borderColor: theme?.palette?.support?.navy || 'black',
            borderTop: 'none'
          }}
        />
        <MUIStack direction="row" alignItems="center" justifyContent="flex-end" gap={2} sx={{ mt: 6 }}>
          <MUIButton variant="text" onClick={() => onClose()} disabled={isInEditMode || isInCreateMode}>
            Cancel
          </MUIButton>
          <MUIButton
            variant="contained"
            onClick={() => onClose(selectedItem || null)}
            disabled={isInEditMode || isInCreateMode || !selectedItem}
          >
            Select
          </MUIButton>
        </MUIStack>
      </Modal>
    </div>
  )
}

ContactsOrganisationsSelectModal.propTypes = {
  open: PropTypes.bool, // from confirmable. indicates if the dialog is shown or not.
  onClose: PropTypes.func, // from confirmable. call to close the dialog with promise resolved.
  initialSelectedItem: PropTypes.any,
  mode: PropTypes.oneOf(['contacts', 'organisations']),
  preSelectExpertTypeId: PropTypes.any
}
